<template>
  <div>
    <Navbar />
    <div class="kova-width container">
      <div class="row" v-if="!loading" style="margin-top: 140px;">
        <div class="col-12 col-sm-6 col-md-6 mb-4">
          <div class="card activecard border-none">
            <div class="card-body">
              <div class="row">
                <div class="col-8 col-sm-8 col-md-8 text-left">
                  <p class="title">{{selectedProject.Title}}</p>
                </div>
                <div class="col-4 col-sm-4 col-md-4">
                  <span
                    class="id text-white px-2 py-1"
                    style="font-size: 14px; font-weight: 700;"
                  >ID: {{selectedProject.ID}}</span>
                </div>
              </div>
              <div class="w-100 divider" />
              <div class="row mt-3 pb-0">
                <div class="col-sm-6 col-md-6 text-left">
                  <p class="subtitle mb-0">
                    Talent Hired
                    <span
                      class="id text-white ml-2 px-2 py-1"
                      style="font-size: 14px; font-weight: 700;"
                    >{{selectedProject.Talents ? selectedProject.Talents.length : 0 }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-12 col-sm-6 col-md-3 mb-4" v-for="item in otherProjects" :key="item.ID"> 
          <div class="card non-activecard border-none" >
            <div class="card-body" @click="switchSelected(item)">
              <div class="row mb-2">
                <div class="col-sm-12 col-md-12 text-left">
                  <p class="title mb-2">{{item.Title}}</p>
                </div>
              </div>
              <div class="w-100 divider" />
              <div class="row mt-3">
                <div class="col-sm-12 col-md-12 text-left">
                  <p class="subtitle mb-0">
                    Talent Hired
                    <span
                      class="id ml-2 text-white px-2 py-1"
                      style="font-size: 14px; font-weight: 700;"
                    >{{item.Talents ? item.Talents.length: 0 }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else style="margin-top: 140px;">
        <a-skeleton active :paragraph="{ rows: 4 }" :title="false" />
      </div>

      <div class="row mt-3 mb-4">
        <div class="col-6 col-sm-6 col-md-6">
          <p class="text-left">Total Projects: 4</p>
        </div>
        <div class="col-6 col-sm-6 col-md-6 text-right">
          <a href class="text-right">View more</a>
        </div>
      </div>

      <div class="card mb-4 border-none" style="background: #f8f8f8;">
        <div class="row card-body" style="padding: 14px;">
          <div class="col-12 col-sm-6 col-md-6 mb-4" >
            <div class="card border-none" style="height: 100%;">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12">
                    <div class="card border-none">
                      <div class="card-body pt-0 pl-0">
                        <div class="row" v-if="!loading">
                          <div class="col-12 col-sm-12 col-md-12 text-left">
                            <p class="title2">Account Manager</p>
                          </div>
                          <div class="col-3 col-sm-3 col-md-3 pr-0 mr-0">
                            <img
                              src="../assets/kovatek/dev.png"
                           
                              alt
                              class="rounded-circle img-fluid"
                            />
                          </div>
                          <div class="col-9 col-sm-9 col-md-9 text-left ">
                            <h6
                              style="letter-spacing: 1px;"
                              class="col-12 font-weight-bolder mb-4 mt-4 text-capitalize"
                            >
                              <font-awesome-icon
                                class="mr-1"
                                style="font-size: 18px;color:#2a4799"
                                :icons="['fab','github']"
                              ></font-awesome-icon>Itunu Jesse
                            </h6>
                            <p class="col-12 font-weight-bold">
                              <font-awesome-icon
                                class="mr-1"
                                style="font-size: 18px;color:#2a4799"
                                icon="phone-alt"
                              ></font-awesome-icon>+234 8012 456 478
                            </p>
                            <p class="col-12 font-weight-light">
                              <font-awesome-icon
                                class="mr-1"
                                style="font-size: 18px;color:#2a4799"
                                icon="envelope"
                              ></font-awesome-icon>itunijesse@kovatek.team
                            </p>
                            <p class="col-12 font-weight-light mb-4">
                              <font-awesome-icon
                                class="mr-1"
                                :icon="['fab', 'skype']"
                                style="font-size: 18px;color:#2a4799"
                              />itunujesse
                            </p>

                            <button
                              style="cursor:pointer"
                              class="mb-3 btn-kovatek rounded"
                            >
                              <span class="text-center py-4 schedulebtn">Schedule a call</span>
                              <span
                                class=" py-2 pr-3 ml-4  border border-top-0 border-bottom-0 border-right-0"
                              >
                                <font-awesome-icon style="font-size: 14px;" icon="plus"></font-awesome-icon>
                              </span>
                            </button>
                          </div>
                        </div>
                        <div v-else>
                          <a-skeleton active avatar :paragraph="{ rows: 4 }" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6" >
            <div class="card border-none">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <div class="card border-none">
                      <div class="card-body pt-0">
                        <div v-if="!loading">
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-12 text-left">
                            <p class="title2">Activity Updates</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-3 col-sm-3 col-md-3 text-left">
                            <p
                              class="font-weight-bolder"
                              style="margin-bottom: 33px;"
                              v-for="index in 4"
                              :key="index"
                            >23rd May</p>
                          </div>
                          <div class="col-1 col-sm-1 col-md-1">
                            <div class="horizontalline"></div>
                          </div>

                          <div class="col-7 col-sm-8 col-md-6 text-left">
                            <div class v-for="index in 4" :key="index">
                              <div> <p
                                class
                                style="margin-bottom: 0px;, font-size: 16px; font-weight: 700; color: #4bb38e"
                              >United Bank of Africa     <font-awesome-icon
                              class=""
                              style="font-size: 23px; float: right; color:#4BB38E;"
                              icon="check-circle"
                            ></font-awesome-icon></p>
                           
                            
                              

                              </div>
                                <p style="color: #a9acaf; ">Account number</p>
                             
                            </div>
                          </div>
                       
                        </div>
                        </div>
                        <div v-else>
                          <a-skeleton active :paragraph="{ rows: 4 }" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border-none mb-5" style="background: #f8f8f8;">
        <div class="row card-body">
          <div class="col-sm-4 col-md-4">
            <JobPost
              :title="selectedProject.Title"
              :status="selectedProject.Status"
              :id="selectedProject.ID"
              :text="selectedProject.Title"
            />
          </div>
          <div class="col-sm-4 col-md-4 mb-3">
            <div class="card border-none">
              <div class="card-body" style="opacity: 0.5">
                <div class="row">
                  <div class="col-sm-6 col-md-6 text-left">
                    <p class="subtitle">Overall</p>
                  </div>
                  <div class="col-sm-6 col-md-6">
                    <a-progress type="circle" :percent="50" strokeColor="#4BB38E" strokeWidth="10" />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-6 col-md-6" v-for="index in 4" :key="index">
                    <span
                      class="infotab px-1 py-1 ml-0 mb-3 rounded font-weight-bold"
                    >Total Issues: 0</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-md-4 ">
            <div class="card border-none">
              <div class="card-body" style="opacity: 0.5">
                <div class="row">
                  <div class="col-sm-6 col-md-6">
                    <p class="subtitle">Team Performance</p>
                  </div>
                  <div class="col-sm-6 col-md-6">
                    <a-progress type="circle" :percent="65" strokeColor="#4BB38E" strokeWidth="10" />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-8 col-md-8 mt-2">
                    <span
                      class="infotab px-1 py-1 ml-0 mb-3 rounded font-weight-bold"
                    >Total number of Team: 5</span>
                  </div>
                  <div class="col-sm-4 col md-4">
                    <font-awesome-icon
                      class="mr-1"
                      style="font-size: 25px;color:#4bb38e"
                      icon="user-friends"
                    ></font-awesome-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-12 mt-3">
            <div class="card border-none">
              <div class="card-body">
                <div class="row">
                  <div
                    v-for="talent in selectedProject.Talents"
                    :key="talent.ID"
                    class="col -6 col-sm-6 col-md-6 mt-4"
                  >
                    <div class="row">
                      <div class="col-3 col-sm-3 col-md-3" style="padding-right: 8px">
                        <img src="../assets/kovatek/dev.png" alt class="rounded-circle img-fluid" />
                      </div>
                      <div class="col-9 col-sm-9 col-md-9 text-left mb-4" style="padding-left: 0px">
                        <p class="text2 mb-1">
                          {{ talent.Profile.Setting.Firstname}} {{ talent.Profile.Setting.Surname}}
                          <img
                            class="img-fluid"
                            style="height:22px;"
                            src="../assets/kovatek/correct.svg"
                            alt
                          />
                        </p>
                        <p class="text mb-2">{{ talent.Profile.Speciality }}</p>
                        <p class="text-uppercase center text-left mb-3 text-intermediate ctrl-heading3" style="font-size: 13px" >{{ computeLevel(talent.Profile.SeniorityLevel) }}</p>


                        <div style="display: inline-block;"> <span
                          v-for="skill in mergeSkills(talent.Profile.CoreTechstack, talent.Profile.OtherCoreTechstacks)"
                          :key="skill"
                          class="bg-skills px-3 mr-3 py-2 mb-3 rounded text-size4"
                        >{{skill}}</span></div>
                       
                        <div class="row mt-3">
                          <div class="col-5 col-sm-5 col-md-5 text-left">
                            <router-link :to="`/dev-profile?id=${talent.Profile.UserID}`">
                              <span class="ant-color pointer">View more details</span>
                            </router-link>
                          </div>
                          <div class="col-4 col-sm-4 col-md-4 text-right">
                            <p>{{ talent.Profile.City }}, {{ talent.Profile.Country }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-12 text-center">
                    <span
                      @click="getRecommendedTalents()"
                      class="btn-kovatek py-2 px-4 invite shadow-sm pointer rounded"
                    >Recommend Talent</span>
                  </div>
                </div>

                <div class="row">
                  <div
                    v-for="talent in recommendedtalents"
                    :key="talent.ID"
                    class="col-sm-6 col-md-6 mt-4"
                  >
                    <div class="row">
                      <div class="col-sm-3 col-md-3" style="padding-right: 0px">
                        <img src="../assets/kovatek/dev.png" alt class="rounded-circle img-fluid" />
                      </div>
                      <div class="col-sm-9 col-md-9 text-left mb-4" style="padding-left: 0px">
                        <p class="text2 mb-1">
                          Mike P
                          <img
                            class="img-fluid"
                            style="height:22px;"
                            src="../assets/kovatek/correct.svg"
                            alt
                          />
                        </p>
                        <p class="text mb-1">{{ computeLevel(talent.Profile.SeniorityLevel) }}</p>

                        <span
                          v-for="skill in talent.Profile.Skills"
                          :key="skill"
                          class="bg-skills px-3 mr-3 py-2 mb-3 rounded text-size4"
                        >{{skill}}</span>
                        <div class="row mt-3">
                          <div class="col-sm-5 col-md-5 text-left">
                            <a href>View more details</a>
                          </div>
                          <div class="col-sm-4 col-md-4 text-right">
                            <p>{{ talent.Profile.City }}, {{ talent.Profile.Country }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import JobPost from "@/components/JobPost.vue";
import Footer from "@/components/Footer.vue";
import { computeExperienceLevel } from "@/helpers/compute.js";
/* 

import { HollowDotsSpinner } from "epic-spinners"; */

export default {
  name: "employer-dashboard",
  components: {
    Navbar,
    JobPost,
    Footer
    /*  ,
    
    HollowDotsSpinner */
  },
  data() {
    return {
      projects: [],
      hasCompletedProject: false,
      completedProjects: [],
      error: "",
      recommendedtalents: [],
      currentprojectid: null,
      selectedProject: [],
      otherProjects: [],
      loading: true
    };
  },
  methods: {
    computeLevel(level) {
      return computeExperienceLevel(level);
    },
    mergeSkills(CoreTechstack, OtherCoreTechstacks) {
      const array = CoreTechstack.split(',');
      for (let i = 0; i < OtherCoreTechstacks.length; i++) {
        array.push(OtherCoreTechstacks[i]);
      }
      return array;
    }, 
    switchSelected(project) {
   
 if (this.projects.length >= 1) {
          this.currentprojectid = project.ID;
          this.selectedProject = project;
          this.otherProjects = this.projects.filter(
            projects => projects.ID !== this.currentprojectid
          );
        }
    },
    goBack() {
      this.$router.go(-1);
    },
    getRecommendedTalents() {
      let projectId = this.currentprojectid;
      this.$store
        .dispatch("profiles/recommendTalent", projectId)
        .then(resp => {
          this.recommendedtalents = resp.data;
          this.loading = false;
        })
        .catch(err => {
          this.error = err.message;
          this.loading = false;
        });
    }
  },
  mounted: function() {
    this.$store
      .dispatch("projects/getProjects", { offset: 0, limit: 20 })
      .then(resp => {
        this.projects = resp.data;
        if (this.projects.length >= 1) {
          this.currentprojectid = this.projects[0].ID;
          this.selectedProject = this.projects[0];
          this.otherProjects = this.projects.filter(
            projects => projects.ID !== this.currentprojectid
          );
        }
        this.projects.map(item => {
          if (item.Status === 6) {
            this.completedProjects.push(item);
            this.hasCompletedProject = true;
          }
        });

        this.loading = false;
      })
      .catch(err => {
        this.error = err.message;
        this.loading = false;
      });
  }
};
</script>

<style scoped>
.id {
  height: 20px;
  background-color: #4bb38e;
  border-radius: 5px;
}
.divider {
  height: 2px;
  background: #b5c2dd;
}
.horizontalline {
  height: 80%;
  width: 1px;
  background: black;
}
.bg-skills {
  background-color: #4bb38e;
  color: #fff;
}
.activecard {
  background: #e9edf5;
}
.non-activecard {
  background: #efefef;
}
.border-none {
  border: none !important;
}
.title {
  font-size: 20px;
  font-weight: 700;
  color: #3a57a2;
}
.subtitle {
  font-size: 14px;
  font-weight: 700;
  color: black;
}

.title2 {
  font-size: 18px;
  font-weight: 700;
  color: black;
}

.btn-kovatek {
  background-color: #20409a;
  color: #fff;
  transition: 0.25s;
  max-width: 196px;
}
.btn-kovatek:hover {
  background-color: #06216d;
  color: #fff;
}
.text {
  font-size: 14px;
  font-weight: 700;
}
.text2 {
  font-size: 18px;
  font-weight: 700;
  color: #3a57a2;
}

.text-intermediate {
  color: #bdbd50;
}
/* .container {
  max-width: 87%;
} */
.infotab {
  background: #4bb38e;
  color: white;
  min-width: 130px;
  max-height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>